module.exports = __webpack_public_path__ + "img/new-food-taco.95f426ec.png";